import { Fragment, useEffect, useRef, useState } from "react";
import { RouteComponentProps } from "../../models/RouteComponent";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Grid } from "@mui/material";
import { FormControl, FormLabel } from "@mui/joy";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { InputTextarea } from "primereact/inputtextarea";
import DropdownApi from "../../components/DropdownApi";
import S3DocumentsUpload from "../../components/S3DocumentsUpload";
import ImageS3Upload from "../../components/ImageS3Upload";
import { Calendar } from "primereact/calendar";
import IntervalDropdown from "../../components/IntervalDropdown";
import RiskAssessmentComponent from "../../components/RiskAssessmentComponent";
import { useNavigate, useParams } from "react-router-dom";
import useApiService from "../../hooks/useApiService";
import ToolboxTalksAttendanceView from "./toolbox-talks-attendance-view";

export default function ToolboxTalksDetails(props: RouteComponentProps) {

  const navigate = useNavigate();
  const { toolbox_id } = useParams<{ toolbox_id: string }>();
  const toast = useRef(null as any);


  if (!toolbox_id) {
    navigate("/toolbox-talk-table");
  }

  const { data, loading, error } = useApiService<any>({
    method: "GET",
    url: `toolbox-talk/${toolbox_id}`,
    apiName: "core"
  });




  return (
    <Fragment>
      <TabView>
        <TabPanel header="Preview">
          <Card>
            <div dangerouslySetInnerHTML={{ __html: data?.body || "" }} />
          </Card>
        </TabPanel>
        <TabPanel header="Attendance">
          <ToolboxTalksAttendanceView toolbox_date={data?.created_at} toolbox_topic={data?.topic} {...props} />
        </TabPanel>
      </TabView>
      <Button
        type="button"
        icon="pi pi-save"
        label="Save"
        className="p-button-outlined"
        size="small"
        style={{
          position: "absolute",
          fontSize: "small",
          right: 70,
          top: 75,
          color: "#2dd36f",
        }}
      />

      <Toast ref={toast} />
    </Fragment>
  );
}
